module.exports = __webpack_public_path__ + "img/ad.1d61da41.png";